import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, deliveryActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, deliveryActions);

export default slice.reducer;
